import { Pipe, PipeTransform } from "@angular/core";
import { ColWidth } from "../model/colWidth";
import { HdTableColumn } from "./hd-table.service";

export interface HdTableCellView {
  display: string | number;
  title: string | null;
  isEmpty: boolean;
  overflow: boolean;
}

@Pipe({ name: "hdTableCell", pure: true })
export class HdTableCellPipe implements PipeTransform {
  transform(data: any, col: HdTableColumn): HdTableCellView {
    if (!data || !col) {
      return { display: "<空>", title: null, isEmpty: true, overflow: false };
    }
    const raw = getHdTableCellRaw(data, col);
    const isEmpty = !(raw || raw === 0);
    const display = isEmpty ? "<空>" : raw;
    const maxWidth = col.width || ColWidth.fixColWidth;
    let overflow = false;
    let title: string | null = null;
    if (!isEmpty) {
      const str = String(raw);
      overflow = estimateTextWidth(str) >= maxWidth;
      if (overflow) {
        title = str;
      }
    }
    return { display, title, isEmpty, overflow };
  }
}

/** 估算文本像素宽度（中文约 14px，英文约 8px） */
function estimateTextWidth(str: string): number {
  let width = 15;
  for (let i = 0; i < str.length; i++) {
    width += str.charCodeAt(i) > 255 ? 14 : 8;
  }
  return width;
}

function getHdTableCellRaw(data: any, col: HdTableColumn): any {
  if (col.render) {
    return col.render(data);
  }
  const name = col.name;
  if (typeof name === "function") {
    return name(data);
  }
  if (typeof name === "string") {
    return data[name];
  }
  return undefined;
}
